export default "__VITE_ASSET__BioOMRKM__"